// @flow
import React from 'react';
import type {Node} from 'react';
import type {TranslateType} from '../../types.js';
import styles from './Assessment.css';
import formStyles from '../../styles/form.module.css';

type StateType = {
  completed: boolean,
  submitted: boolean,
  passed: boolean,
  error: string
};

type MethodsType = {
  handleSubmit: () => void,
  reset: () => void,
  completeAssessmentButton: () => void
};

const AssessmentButtons = ({
  state,
  methods,
  t,
}: {state: StateType, methods: MethodsType, t: TranslateType}): Node => (
  <div style={{
      display: 'flex',
      justifyContent: 'flex-end'
  }}>
      <button style={{
          marginRight: '15px'
      }}
              className={formStyles.buttonBcg} onClick={(): void => methods.completeAssessmentButton()}>
          {t('return')}
      </button>
      {
        !state.submitted
        && <button className={formStyles.buttonBcg} onClick={(): void => methods.handleSubmit()}>
          {t('checkAnswers')}
        </button>
      }
      {
        state.submitted && !state.passed
        && <button className={formStyles.buttonBcg} onClick={(): void => methods.reset()}>
          {t('tryAgain')}
        </button>
      }
      {
        state.submitted && state.passed
        && <button className={formStyles.buttonBcg} onClick={(): void => methods.completeAssessmentButton()}>
          {t('complete')}
        </button>
      }
  </div>
);

export default AssessmentButtons;



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessmentButtons.js